import { i as copy_payload, j as assign_payload, p as pop, a as push, k as ensure_array_like, h as head, b as attr, e as escape_html, n as maybe_selected, c as attr_class, f as clsx } from "../../../../chunks/index2.js";
import { p as page } from "../../../../chunks/index3.js";
import { g as goto } from "../../../../chunks/client2.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
import { M as Modal } from "../../../../chunks/Modal.js";
import { P as Pagination } from "../../../../chunks/Pagination.js";
import { P as ProductFilterSidebar } from "../../../../chunks/ProductFilterSidebar.js";
import "../../../../chunks/validationSchemas.js";
function _page($$payload, $$props) {
  push();
  const { form, data } = $$props;
  const products = data.products || [];
  const categories = data.categories || [];
  const currentPage = data.page || 1;
  const totalPages = data.totalPages || 1;
  const totalResults = data.totalResults || 0;
  let selectedCategories = [];
  let selectedYear = "all";
  let itemsPerPage = "12";
  let searchQuery = "";
  let sortBy = "newest";
  let isMobileFiltersOpen = false;
  let showAddModal = false;
  getToastState();
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const years = Array.from({ length: currentYear - 1960 + 1 }, (_, i) => currentYear - i);
  const itemsPerPageOptions = [
    { value: "12", label: "12 records" },
    { value: "24", label: "24 records" },
    { value: "50", label: "50 records" },
    { value: "100", label: "100 records" },
    { value: "1000", label: "1000 records" }
  ];
  function updateURL(categories2 = [], year = "all", page2 = 1, limit = "12", search = "", sort = "newest") {
    const url = new URL(window.location.href);
    url.searchParams.set("categories", categories2.join(","));
    url.searchParams.set("year", year);
    url.searchParams.set("page", page2.toString());
    url.searchParams.set("limit", limit);
    url.searchParams.set("search", search);
    url.searchParams.set("sort", sort);
    return goto(url.toString(), {});
  }
  function handleCategoryToggle(categoryId) {
    let newSelectedCategories;
    if (selectedCategories.includes(categoryId)) {
      newSelectedCategories = selectedCategories.filter((id) => id !== categoryId);
    } else {
      newSelectedCategories = [...selectedCategories, categoryId];
    }
    updateURL(newSelectedCategories, selectedYear, 1, itemsPerPage, searchQuery, sortBy);
  }
  function handleYearChange(year) {
    updateURL(selectedCategories, year, 1, itemsPerPage, searchQuery, sortBy);
  }
  function handlePageChange(page2) {
    updateURL(selectedCategories, selectedYear, page2, itemsPerPage, searchQuery, sortBy);
  }
  function clearFilters() {
    updateURL([], "all", 1, "12", "", "newest");
  }
  function toggleMobileFilters() {
    isMobileFiltersOpen = !isMobileFiltersOpen;
  }
  let name = form?.data?.name;
  let description = form?.data?.description || "";
  let price = form?.data?.price;
  let quantity = form?.data?.quantity;
  form?.data?.serviceCode;
  const formAny = form?.data || {};
  let author = formAny.author;
  let citation = formAny.citation || "";
  let isbn = formAny.isbn || "";
  let pageCount = formAny.pageCount;
  let publicationDateISO = formAny.publicationDate;
  let selectedCategoriesModal = [];
  selectedCategoriesModal.map((c) => c.id);
  let publicationDate = publicationDateISO ? new Date(publicationDateISO.toString()).getFullYear().toString() : "";
  let formErrors = form?.errors || {};
  const getFieldError = (field) => formErrors[field]?.[0] || "";
  const allowedExtensions = [".jpg", ".jpeg", ".png", ".webp"];
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    const each_array = ensure_array_like(itemsPerPageOptions);
    head($$payload2, ($$payload3) => {
      $$payload3.title = `<title>Manage Products | Admin</title>`;
    });
    $$payload2.out.push(`<div class="container mx-auto px-4 py-8"><div class="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"><div><h1 class="text-3xl font-bold">Products Catalog</h1></div> <div class="flex gap-4"><button class="bg-primary hover:bg-primary/90 cursor-pointer rounded-lg px-4 py-2 text-white">Add Product</button></div></div> <div class="flex gap-8">`);
    ProductFilterSidebar($$payload2, {
      categories,
      selectedCategories,
      selectedYear,
      years,
      isMobileFiltersOpen,
      onCategoryToggle: handleCategoryToggle,
      onYearChange: handleYearChange,
      onClearFilters: clearFilters,
      onToggleMobileFilters: toggleMobileFilters
    });
    $$payload2.out.push(`<!----> <main class="flex-1"><div class="mb-6"><form class="flex gap-2"><div class="relative flex-1"><input type="text" placeholder="Search products..."${attr("value", searchQuery)} class="focus:border-primary focus:ring-primary/30 w-full rounded-lg border border-gray-300 px-4 py-2 pl-10 focus:ring-5 focus:outline-hidden"/> <i class="bi bi-search absolute top-1/2 left-3 -translate-y-1/2 text-gray-400"></i></div> <button type="submit" class="bg-primary hover:bg-primary/90 rounded-lg px-6 py-2 text-white transition-colors">Search</button> `);
    {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--></form></div> <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"><div class="flex items-center gap-4"><button class="rounded-lg bg-gray-100 p-2 md:hidden" aria-label="Toggle filters"><i class="bi bi-funnel text-sm"></i></button> <span class="text-sm text-gray-600">${escape_html(totalResults)} results</span> `);
    if (selectedCategories.length > 0 || selectedYear !== "all" || page.url.searchParams.get("search")) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<button class="text-primary hover:text-primary/80 text-sm underline">Clear All Filters</button>`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--></div> <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4"><div class="flex items-center gap-2"><label for="items-per-page" class="text-sm whitespace-nowrap text-gray-600">Show:</label> <select id="items-per-page" class="focus:border-primary focus:ring-primary/30 min-w-[120px] rounded border border-gray-200 px-2 py-1 text-sm focus:ring-5 focus:outline-hidden">`);
    $$payload2.select_value = itemsPerPage;
    $$payload2.out.push(`<!--[-->`);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let option = each_array[$$index];
      $$payload2.out.push(`<option${attr("value", option.value)}${maybe_selected($$payload2, option.value)}>${escape_html(option.label)}</option>`);
    }
    $$payload2.out.push(`<!--]-->`);
    $$payload2.select_value = void 0;
    $$payload2.out.push(`</select></div> <div class="flex items-center gap-2"><label for="sort-by" class="text-sm whitespace-nowrap text-gray-600">Sort by:</label> <select id="sort-by" class="focus:border-primary focus:ring-primary/30 min-w-[140px] rounded border border-gray-200 px-2 py-1 text-sm focus:ring-5 focus:outline-hidden">`);
    $$payload2.select_value = sortBy;
    $$payload2.out.push(`<option value="newest"${maybe_selected($$payload2, "newest")}>Newest First</option><option value="price_asc"${maybe_selected($$payload2, "price_asc")}>Price: Low to High</option><option value="price_desc"${maybe_selected($$payload2, "price_desc")}>Price: High to Low</option><option value="name_asc"${maybe_selected($$payload2, "name_asc")}>Name: A to Z</option>`);
    $$payload2.select_value = void 0;
    $$payload2.out.push(`</select></div></div></div> <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">`);
    if (products.length === 0) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<div class="col-span-full text-center text-gray-500">No products found</div>`);
    } else {
      $$payload2.out.push("<!--[!-->");
      const each_array_1 = ensure_array_like(products);
      $$payload2.out.push(`<!--[-->`);
      for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
        let product = each_array_1[$$index_1];
        $$payload2.out.push(`<div class="group relative rounded-lg border bg-white p-4 shadow-sm transition-shadow hover:shadow-md"><div class="flex gap-4"><div class="h-32 w-32 shrink-0 overflow-hidden rounded-lg"><img${attr("src", product.Image[0]?.url || "/coat-of-arms.jpg")}${attr("alt", product.name)} loading="lazy" class="h-full w-full object-cover"/></div> <div class="grow"><div class="flex items-start justify-between"><div><h3 class="font-semibold">${escape_html(product.name)}</h3> <p class="text-sm text-gray-600">Code: ${escape_html(product.serviceCode)}</p> <p class="text-xs text-gray-500">Sort order: ${escape_html(product.sortOrder)}</p></div> <div class="flex gap-2">`);
        if (product.isPublished) {
          $$payload2.out.push("<!--[-->");
          $$payload2.out.push(`<span class="rounded-full bg-green-100 px-2 py-1 text-xs text-green-700">Published</span>`);
        } else {
          $$payload2.out.push("<!--[!-->");
          $$payload2.out.push(`<span class="rounded-full bg-gray-100 px-2 py-1 text-xs text-gray-700">Draft</span>`);
        }
        $$payload2.out.push(`<!--]--></div></div> <div class="mt-2 grid grid-cols-2 gap-2 text-sm"><div><span class="text-gray-500">Price:</span> <span class="ml-1 font-medium">KES ${escape_html(product.price.toLocaleString())}</span></div> <div><span class="text-gray-500">Stock:</span> <span class="ml-1 font-medium">${escape_html(product.quantity)}</span></div></div></div></div> <a${attr("href", `/admin/product/${product.id}`)} class="mt-4 inline-flex w-full items-center justify-center rounded-md bg-gray-100 px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-200">Edit Product</a></div>`);
      }
      $$payload2.out.push(`<!--]-->`);
    }
    $$payload2.out.push(`<!--]--></div> <div class="mt-8">`);
    Pagination($$payload2, { currentPage, totalPages, onPageChange: handlePageChange });
    $$payload2.out.push(`<!----></div></main></div></div> `);
    Modal($$payload2, {
      title: "Add New Product",
      modalClass: "max-w-7xl max-h-4/5",
      get show() {
        return showAddModal;
      },
      set show($$value) {
        showAddModal = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        const each_array_2 = ensure_array_like(categories);
        $$payload3.out.push(`<form method="POST" enctype="multipart/form-data" class="space-y-4">`);
        if (formErrors._errors) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<div class="rounded-md bg-red-50 p-3 text-sm text-red-500">${escape_html(formErrors._errors[0])}</div>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <div class="grid grid-cols-1 gap-4 lg:grid-cols-2"><div class="space-y-2"><label for="name" class="text-sm font-medium text-gray-700">Book Title</label> <input type="text" id="name" name="name"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("name"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", name)}${attr("aria-invalid", !!getFieldError("name"))}${attr("aria-describedby", getFieldError("name") ? "name-error" : void 0)} placeholder="e.g., The Constitution of Kenya"/> `);
        if (getFieldError("name")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="name-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("name"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="price" class="text-sm font-medium text-gray-700">Price (KES)</label> <input type="number" id="price" name="price"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("price"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", price)}${attr("aria-invalid", !!getFieldError("price"))}${attr("aria-describedby", getFieldError("price") ? "price-error" : void 0)} min="0" placeholder="1500" required/> `);
        if (getFieldError("price")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="price-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("price"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="quantity" class="text-sm font-medium text-gray-700">Quantity</label> <input type="number" id="quantity" name="quantity"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("quantity"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", quantity)}${attr("aria-invalid", !!getFieldError("quantity"))}${attr("aria-describedby", getFieldError("quantity") ? "quantity-error" : void 0)} min="0" placeholder="e.g., 100" required/> `);
        if (getFieldError("quantity")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="quantity-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("quantity"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="author" class="text-sm font-medium text-gray-700">Author</label> <input type="text" id="author" name="author"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("author"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", author)}${attr("aria-invalid", !!getFieldError("author"))}${attr("aria-describedby", getFieldError("author") ? "author-error" : void 0)} placeholder="National Council for Law Reporting (Kenya Law)." required/> `);
        if (getFieldError("author")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="author-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("author"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="citation" class="text-sm font-medium text-gray-700">Citation <span class="text-gray-500">(optional)</span></label> <input type="text" id="citation" name="citation"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("citation"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", citation)}${attr("aria-invalid", !!getFieldError("citation"))}${attr("aria-describedby", getFieldError("citation") ? "citation-error" : void 0)} placeholder=""/> `);
        if (getFieldError("citation")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="citation-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("citation"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="isbn" class="text-sm font-medium text-gray-700">ISBN <span class="text-gray-500">(optional)</span></label> <input type="text" id="isbn" name="isbn"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("isbn"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", isbn)}${attr("aria-invalid", !!getFieldError("isbn"))}${attr("aria-describedby", getFieldError("isbn") ? "isbn-error" : void 0)} placeholder="978-0-123456-78-9"/> `);
        if (getFieldError("isbn")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="isbn-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("isbn"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="pageCount" class="text-sm font-medium text-gray-700">Page Count</label> <input type="number" id="pageCount" name="pageCount"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("pageCount"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", pageCount)}${attr("aria-invalid", !!getFieldError("pageCount"))}${attr("aria-describedby", getFieldError("pageCount") ? "pageCount-error" : void 0)} min="0" placeholder="e.g., 250" required/> `);
        if (getFieldError("pageCount")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="pageCount-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("pageCount"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="publicationDate" class="text-sm font-medium text-gray-700">Publication Year</label> <input type="number" id="publicationDate" name="publicationDate"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("publicationDate"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("value", publicationDate)}${attr("aria-invalid", !!getFieldError("publicationDate"))}${attr("aria-describedby", getFieldError("publicationDate") ? "publicationDate-error" : void 0)} placeholder="e.g., 2024" min="1900" max="2030" required/> `);
        if (getFieldError("publicationDate")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="publicationDate-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("publicationDate"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div></div> <div class="space-y-2"><label for="description" class="text-sm font-medium text-gray-700">Description</label> <textarea id="description" name="description"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("description"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("aria-invalid", !!getFieldError("description"))}${attr("aria-describedby", getFieldError("description") ? "description-error" : void 0)} placeholder="Enter a detailed description of the book" required rows="3">`);
        const $$body = escape_html(description);
        if ($$body) {
          $$payload3.out.push(`${$$body}`);
        }
        $$payload3.out.push(`</textarea> `);
        if (getFieldError("description")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="description-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("description"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-2"><label for="categories" class="text-sm font-medium text-gray-700">Select Categories</label> <select name="categoryIds"${attr_class(clsx({
          "w-full rounded-sm border-2 p-2": true,
          "border-red-500": !!getFieldError("categoryIds"),
          "focus:border-primary focus:ring-primary focus:ring-1 focus:outline-hidden": true
        }))}${attr("aria-invalid", !!getFieldError("categoryIds"))}${attr("aria-describedby", getFieldError("categoryIds") ? "categories-error" : void 0)}><option value=""${maybe_selected($$payload3, "")}>--</option><!--[-->`);
        for (let $$index_2 = 0, $$length = each_array_2.length; $$index_2 < $$length; $$index_2++) {
          let category = each_array_2[$$index_2];
          if (!selectedCategoriesModal.find((c) => c.id === category.id)) {
            $$payload3.out.push("<!--[-->");
            $$payload3.out.push(`<option${attr("value", category.id)}${maybe_selected($$payload3, category.id)}>${escape_html(category.name)}</option>`);
          } else {
            $$payload3.out.push("<!--[!-->");
          }
          $$payload3.out.push(`<!--]-->`);
        }
        $$payload3.out.push(`<!--]--></select> `);
        if (getFieldError("categoryIds")) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p id="categories-error" class="mt-1 text-xs text-red-600">${escape_html(getFieldError("categoryIds"))}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <div class="flex flex-wrap gap-2">`);
        if (selectedCategoriesModal.length === 0) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-sm text-gray-500">No categories selected</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
          const each_array_3 = ensure_array_like(selectedCategoriesModal);
          $$payload3.out.push(`<!--[-->`);
          for (let $$index_3 = 0, $$length = each_array_3.length; $$index_3 < $$length; $$index_3++) {
            let category = each_array_3[$$index_3];
            $$payload3.out.push(`<div class="flex items-center gap-2 rounded-md bg-gray-100 px-3 py-1"><span class="text-sm">${escape_html(category.name)}</span> <button type="button" class="text-gray-500 hover:text-gray-700">x</button></div>`);
          }
          $$payload3.out.push(`<!--]-->`);
        }
        $$payload3.out.push(`<!--]--></div></div> <div class="space-y-2"><label for="image" class="text-sm font-medium text-gray-700">Book Cover</label> <input type="file" id="image" name="image"${attr("accept", allowedExtensions.join(","))} class="focus:border-primary focus:ring-primary w-full rounded-md border border-gray-300 p-2 focus:ring-1 focus:outline-hidden"/> <p class="text-xs text-gray-500">Accepted formats: ${escape_html(allowedExtensions.join(", "))}</p></div> <div class="space-y-2"><label for="pdfDocuments" class="text-sm font-medium text-gray-700">Attach PDF Documents <span class="text-gray-500">(optional)</span></label> <input id="pdfDocuments" type="file" multiple accept="application/pdf" class="focus:border-primary focus:ring-primary w-full rounded-md border border-dashed border-gray-300 p-2 focus:ring-1 focus:outline-hidden" aria-describedby="pdf-help"/> <p id="pdf-help" class="text-xs text-gray-500">You may select multiple PDF files (max 25MB each).</p></div> <button type="submit" class="bg-primary hover:bg-primary/90 mt-4 w-full cursor-pointer rounded-md px-4 py-2 text-white transition-colors">Add Book</button></form>`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!---->`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
